import 'react';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Spinner/styled.js';
import Spinner from '../Spinner/index.js';
import Input from 'reakit/Input';
var LoadingSpinner = styled(Spinner).withConfig({
  displayName: "styled__LoadingSpinner",
  componentId: "sc-1okmeud-0"
})(["position:absolute;top:12px;right:14px;z-index:1;"]);
var sizeProperties = {
  small: css(["font-size:0.8rem;& + ", "{top:10px;}&{", ";}"], LoadingSpinner, theme('fannypack.Textarea.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Textarea.sizes.default')),
  medium: css(["font-size:1.25rem;& + ", "{top:15px;right:10px;}&{", ";}"], LoadingSpinner, theme('fannypack.Textarea.sizes.medium')),
  large: css(["font-size:1.5rem;& + ", "{top:16px;right:12px;}&{", ";}"], LoadingSpinner, theme('fannypack.Textarea.sizes.large'))
};
var stateProperties = css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
  return palette(props.state + "300")(props);
}, function (props) {
  return palette(props.state + "300")(props);
});
var Textarea = styled(Input).withConfig({
  displayName: "styled__Textarea",
  componentId: "sc-1okmeud-1"
})(["-webkit-appearance:none;border:1px solid #bdbdbd;box-shadow:inset 0px 1px 2px #e5e5e5;border-radius:0.2em;width:100%;padding:0.4em 0.6em;&[disabled]{background-color:", ";box-shadow:unset;&{", ";}}&:focus{outline:unset;z-index:2;border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;&{", ";}}&::placeholder{opacity:0.6;&{", ";}}&{", ";}&{", ";}", ";"], palette('white700'), theme('fannypack.Textarea.disabled'), palette('primary'), palette('primary'), theme('fannypack.Textarea.focus'), theme('fannypack.Textarea.placeholder'), function (props) {
  return props.styledSize && sizeProperties[props.styledSize];
}, function (props) {
  return props.state && stateProperties;
}, theme('fannypack.Textarea.base'));
export default Textarea;
export { LoadingSpinner, Textarea, sizeProperties, stateProperties };